import moment from 'moment';

export const enums = {
    role: [{ value: 1, label: '超级管理员' }, { value: 2, label: '管理员' }, { value: 3, label: '普通用户' }],

    type: [{ value: 0, label: '曝光' }, { value: 1, label: '点击' }, { value: 2, label: '注册点击' }],
};

export const dataTypes = {};

export const formatViewData = (key, values) => {
    if (values) {
        if (enums[key]) {
            let result = [];
            if (typeof values === 'string') {
                values = values.split(',');
            } else if (typeof values === 'number' || typeof values === 'boolean') {
                values = [values];
            }
            for (let value of values) {
                for (let item of enums[key]) {
                    if (item.value === value) {
                        result.push(item.label);
                    }
                }
            }
            return result.join(',');
        } else if (dataTypes[key] === 'date') {
            return moment(values).format('YYYY-MM-DD');
        } else {
            return values;
        }
    }
};

export const formatFormData = values => {
    let result = {};
    Object.keys(values).forEach(key => {
        if (typeof values[key] !== 'undefined') {
            if (key == 'dateTime') {
                if (typeof values[key] == 'object') {
                    values[key].forEach((item, index) => {
                        if (index == 0) {
                            let time = item.valueOf();
                            result['beginTime'] = moment(time).format('YYYY-MM-DD HH:mm:ss');
                        } else {
                            let time = item.valueOf();
                            result['endTime'] = moment(time).format('YYYY-MM-DD HH:mm:ss');;
                        }
                    });
                }
            } else {
                result[key] = values[key];
            }
        }
    });
    return result;
};

export const formItemLayout = {
    labelCol: { span: 4, offset: 2 },
    wrapperCol: { span: 16 },
};



// WEBPACK FOOTER //
// ./pages/fileList/utils.js